module.exports = __webpack_public_path__ + "media/logo/logo_styleport-fb03cdcf.png";